if (!customElements.get("video-reels")) {
  customElements.define(
    "video-reels",
    class VideoReels extends HTMLElement {
      constructor() {
        super();
        this.activeClass = "active";
        this.swiper = this.querySelector(".wt-slider__container");
      }

      connectedCallback() {
        this.swiper = this.querySelector(".wt-slider__container");
        this.sectionVisible = false;
        this.init();
      }

      updateAllVideosSound(swiper) {
        const soundOn = swiper.el.dataset.sound === "on";
        swiper.slides.forEach((slide) => {
          let video = slide.querySelector("video");
          if (video) {
            video.muted = !soundOn;
          }
        });
      }

      observeSection() {
        this.sectionVisible = false;
        this.sectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.sectionVisible = entry.isIntersecting;
            this.pasueAllVideos();
            if (this.sectionVisible && this.swiper?.swiper) {
              this.playVideoInActiveSlide(this.swiper?.swiper);
            }
          });
        }, { root: null, rootMargin: "0px", threshold: 0.1 });
        this.sectionObserver.observe(this);
        this.onVisibilityChange = () => {
          this.pasueAllVideos();
          if (this.swiper?.swiper) this.playVideoInActiveSlide(this.swiper?.swiper);
        };
        document.addEventListener("visibilitychange", this.onVisibilityChange);
      }

      removeSoundToggleHandlers() {
        (this.soundToggleHandlers || []).forEach(({ button, handler }) => {
          button.removeEventListener("click", handler);
        });
        this.soundToggleHandlers = [];
      }

      handleSoundToggle(swiper) {
        this.removeSoundToggleHandlers();
        swiper.slides.forEach((slide) => {
          const button = slide.querySelector(".wt-video__sound-toggle");
          const video = slide.querySelector("video");
          if (!button || !video) return;
          const handler = () => {
            swiper.el.dataset.sound = video.muted ? "on" : "off";
            this.updateAllVideosSound(swiper);
          };
          button.addEventListener("click", handler);
          this.soundToggleHandlers.push({ button, handler });
        });
      }

      pasueAllVideos() {
        const videos = this.querySelectorAll("video");
        videos.forEach((video) => {
          video.pause();
        });
      }

      playVideoInActiveSlide(swiper) {
        if (!this.sectionVisible || document.visibilityState !== "visible") return;
        const sound = swiper.el.dataset.sound;
        const activeSlideVideo =
          this.findActiveSlide(swiper)?.querySelector("video");
        if (activeSlideVideo) {
          activeSlideVideo.muted = sound !== "on";
          activeSlideVideo.playsInline = true;
          const playPromise = activeSlideVideo.play();
          if (playPromise) playPromise.catch(() => {});
        }
      }

      findActiveSlide(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        return activeSlide;
      }

      toggleActiveClass(swiper) {
        const activeSlide = this.findActiveSlide(swiper);
        swiper.slides.forEach((slide) => {
          slide.classList.remove(this.activeClass);

          if (activeSlide === slide) {
            slide.classList.add(this.activeClass);
          }
        });
      }

      handleSlideChange(swiper) {
        this.pasueAllVideos();
        this.toggleActiveClass(swiper);
        this.playVideoInActiveSlide(swiper);
      }

      addVideoEventHandlers(swiper) {
        const that = this;
        this.onSlideChange = (swp) => that.handleSlideChange(swp);
        swiper.on("slideChange", this.onSlideChange);
      }

      checkSwiperInitialization() {
        const swiperContainer = this.swiper;
        if (!swiperContainer) return;
        const mySwiperInstance = swiperContainer.swiper;

        if (mySwiperInstance && swiperContainer.classList.contains("swiper-initialized")) {
          this.addVideoEventHandlers(mySwiperInstance);
          this.handleSlideChange(mySwiperInstance);
          this.handleSoundToggle(mySwiperInstance);
          this.observeSection();
          clearInterval(this.checkInterval);
        }
      }

      disconnectedCallback() {
        clearInterval(this.checkInterval);
        this.sectionObserver?.disconnect();
        this.sectionVisible = false;
        this.removeSoundToggleHandlers();
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
        if (this.onSlideChange) this.swiper?.swiper?.off("slideChange", this.onSlideChange);
        this.pasueAllVideos();
      }

      init() {
        this.checkInterval = setInterval(
          this.checkSwiperInitialization.bind(this),
          500,
        );
      }
    },
  );
}

